import { render } from "./BaseFieldInScript.vue?vue&type=template&id=f35fdb16&scoped=true"
import script from "./BaseFieldInScript.vue?vue&type=script&lang=js"
export * from "./BaseFieldInScript.vue?vue&type=script&lang=js"

import "./BaseFieldInScript.vue?vue&type=style&index=0&id=f35fdb16&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f35fdb16"]])

export default __exports__